import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import { useStyles } from './table';
import { ManageServerRow } from './ManageServerRow';

function ManageServersTable({ data, handleRconClick }) {
    const classes = useStyles();

    return (
        <TableContainer>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow className={classes.headerRow}>
                        <TableCell>Name</TableCell>
                        <TableCell>IP</TableCell>
                        <TableCell>Players</TableCell>
                        <TableCell>Map</TableCell>
                        <TableCell>Mode</TableCell>
                        <TableCell>Manage</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {data.map((row, i) => (
                        <ManageServerRow key={'serverrow' + i} row={row} i={i} handleRconClick={handleRconClick}></ManageServerRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export { ManageServersTable }